import React, { } from 'react';
import { DropDownButton } from '@progress/kendo-react-buttons';
import { useReduxDispatch, useReduxSelector } from '../../../../../redux/hooks';
import { setView, ViewName } from '../../../../../slices/TicketDetailUISlice';
import * as svg from '@progress/kendo-svg-icons';
import { TicketApi } from '../../../../../redux/api/TicketApi';
import { ITicketProps } from '../../../../../types/Ticket/ITicket';
import { SvgIcon } from '@progress/kendo-react-common';

const ToggleView: React.FC<ITicketProps> = (props) => {
    const { data: userProfile } = TicketApi.useGetUserProfileQuery();
    const dispatch = useReduxDispatch();
    const selectedView = useReduxSelector(state => state.ticketDetailsUI.viewName);

    const handleSelect = (view: ViewName) => {
        dispatch(setView(view));
    };

    const getStartIcon = (view: string) => {

        switch (view) {
            case 'notes':
                return <SvgIcon icon={svg.stickyNoteIcon} />
            case 'timeline':
                return <img src='./images/Toolbar/storyline.png' />
            case 'summary':
                return <SvgIcon icon={svg.sparklesIcon} />
            case 'gameplan':
                return <img width={25} src='./images/gameplan-dark.png' />
            default:
                return null;
        }
    };


    if (props?.Is_Loading) return <div className='action-toggle-view'></div>;

    return (
        <div className='action-toggle-view'>
            {
                <DropDownButton size='large' popupSettings={{ popupClass: 'action-popup' }} className='action-dropdown'
                    text={selectedView === 'notes' ? 'Notes' : selectedView === 'timeline' ? 'Storyline' : selectedView === 'summary' ? 'AI Summary' : selectedView === 'gameplan' ? 'Gameplan' : ''}
                    items={[
                        { text: 'Notes', view: 'notes', svgIcon: svg.stickyNoteIcon },
                        userProfile?.Features.Call_History_Timeline && { text: <><img className='pr-1' width={25} src='./images/Toolbar/storyline.png' />Storyline</>, view: 'timeline' },
                        { text: 'AI Summary', svgIcon: svg.sparklesIcon, view: 'summary' },
                        props.Is_Workstream && { text: <><img className='p-1' height={20} src='./images/gameplan-dark.png' />Gameplan</>, view: 'gameplan' }
                    ].filter(Boolean)}
                    onItemClick={(e) => handleSelect(e.item.view)}
                    startIcon={getStartIcon(selectedView)}
                    endIcon={<SvgIcon icon={svg.chevronDownIcon} />}
                />

                // <ButtonGroup>
                //     <Button className={selectedView === 'notes' ? 'summary selected' : 'notes '}
                //         svgIcon={svg.stickyNoteIcon}
                //         selected={selectedView === 'notes'}
                //         onClick={() => handleSelect('notes')}
                //     >Notes</Button>
                //     {userProfile?.Features.Call_History_Timeline && <Button className={selectedView === 'timeline' ? 'timeline selected' : 'timeline '}
                //         svgIcon={svg.bookIcon}
                //         selected={selectedView === 'timeline'}
                //         onClick={() => handleSelect('timeline')}
                //     >Storyline</Button>}
                //     <Button className={selectedView === 'summary' ? 'summary selected' : 'summary '}
                //         svgIcon={svg.sparklesIcon}
                //         selected={selectedView === 'summary'}
                //         onClick={() => handleSelect('summary')}
                //     >AI Summary</Button>
                //     <Button className={selectedView === 'gameplan' ? 'summary selected' : 'summary '}
                //         svgIcon={svg.sparklesIcon}
                //         selected={selectedView === 'gameplan'}
                //         onClick={() => handleSelect('gameplan')}
                //     >Gameplan</Button>
                // </ButtonGroup>
            }
        </div>
    );
};

export default ToggleView;